// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v-w3","label":"styles_label__2HTOR"};